import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    padding: 5px;\n    font-size: ", ";\n    font-weight: ", ";\n\n    &:hover {\n        background-color: ", ";\n    }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    position: absolute;\n    top: 25px;\n    width: 100%;\n    max-height: 165px;\n    overflow-y: auto;\n    overflow-x: hidden;\n    scrollbar-width: thin; /* Firefox only */\n    background-color: ", ";\n    border: ", ";\n    z-index: 10;\n    cursor: pointer;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    position: relative;\n    display: flex;\n    width: 72px;\n    justify-content: space-around;\n    font-size: ", ";\n    font-weight: ", ";\n    color: ", ";\n    cursor: pointer;\n\n    i {\n        font-size: ", ";\n        color: ", ";\n    }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
export var StyledCalendarSlider = styled.div(_templateObject());
export var StyledSelect = styled.div(_templateObject2(), function (props) {
  return props.theme.global.fontSizes.visible;
}, function (props) {
  return props.theme.global.fontWeights.bold;
}, function (props) {
  return props.theme.components.dateRange.controllerColor;
}, function (props) {
  return props.theme.components.dateRange.fontSize;
}, function (props) {
  return props.theme.components.dateRange.controllerColor;
});
export var StyledItems = styled.div(_templateObject3(), function (props) {
  return props.theme.components.calendar.yearsItemsBackground;
}, function (props) {
  return props.theme.components.calendar.yearsItemsBorder;
});
export var StyledItem = styled.div(_templateObject4(), function (props) {
  return props.theme.global.fontSizes.visible;
}, function (props) {
  return props.theme.global.fontWeights.regular;
}, function (props) {
  return props.theme.components.calendar.yearsItemBackground;
});